export const ADDITIONAL_BENEFIT_AMOUNT = 74000;
export const PRODUCT_DETAIL_STALE_TIME = 1000 * 60 * 5;
export const RECOMMENDED_GIFTS_PAGE_SIZE = 8;
export const DONATION_COMPARISON_TEXTS = {
  minBenefit: {
    label: '최소 혜택',
    isHighlighted: false,
    texts: {
      donationAmountText: '10만원 기부 시',
      benefitsText: '세액공제 10만원\n답례품 3만원',
      totalBenefitText: '총 130,000원 혜택',
    },
  },
  maxBenefit: {
    label: '가장 큰 혜택',
    isHighlighted: true,
    texts: {
      donationAmountText: '20만원 기부 시',
      benefitsText: '세액공제 14.4만원\n답례품 6만원',
      totalBenefitText: '총 204,000원 혜택',
    },
  },
} as const;
